import { Component, OnInit } from '@angular/core';

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { AccountTypePipe } from "../account-type.pipe";

import { HttpService } from '../http.service';

import { Domain as WebsideDomain } from "../../../../lib/Domain/Webside"

@Component({
  selector: 'app-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.css']
})
export class AccountListComponent implements OnInit {
  public userlists: WebsideDomain.IAccount[] = [];
  public userTypelists: any[] = AccountTypePipe.getType();

  public selectedUser?: WebsideDomain.IAccount = undefined;
  closeResult: string;
  messageTitle: string;
  messageBody: string;
  OnMessageOKCallback: (callback: () => void) => void;
  OnMessageCancelCallBack: (callback: () => void) => void;

  constructor(private httpService: HttpService, private modalService: NgbModal) { }
  async ngOnInit() {
    this.userlists = await this.httpService.account.List();
  }
  OnCreateNew(content) {
    this.selectedUser = undefined;
    this.modalService.open(content);
  }
  async OnEdit(content, item: WebsideDomain.IAccount) {
    this.selectedUser = item;
    this.modalService.open(content);
  }
  async OnDetail(content, item: WebsideDomain.IAccount) {
    this.selectedUser = item;
    this.modalService.open(content);
  }

  async OnSave($event) {
    let { Item, isCreated, callback } = $event;
    try {
      const result = await this.httpService.account.Update(Item);
      if (isCreated) {
        this.userlists.push(result);
      } else {
        let index = this.userlists.findIndex((v) => {
          return v.uuid === result.uuid;
        });
        if (index > 0) {
          this.userlists[index] = result;
        }
      }
      callback(null);
    } catch (erro) {

      callback(erro);
    }
  }
  async OnDelete(content, $event: WebsideDomain.IAccount) {
    if ($event.email === this.httpService.userinfo.email) {
      return;
    }
    this.messageTitle = "刪除用戶";
    this.messageBody = `確定要刪除用戶${$event.email}?\r\n此動作將會刪除該帳戶下擁有的相關設定並不可還原\r\n按確定繼續`;
    this.OnMessageOKCallback = (d) => {
      try {
        this.httpService.account.Delete($event).then(() => {
          let index = this.userlists.findIndex((v) => {
            return (v.uuid === $event.uuid);
          });
          if (index > -1) {
            this.userlists.splice(index, 1);
          }
        });
      } catch (erro) {
      }
      if (d) { d(); }
    };
    this.OnMessageCancelCallBack = (d) => {
      if (d) { d(); }
    };
    this.modalService.open(content);
  }
  CheckPermission(item: WebsideDomain.IAccount) {
    if (item.usertype >= 0xFFFF) { return false; }
    if (item.usertype > this.httpService.userinfo.usertype) { return false; }
    if (item.email === this.httpService.userinfo.email) { return false; }
    return true;
  }



}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/account-list/account-list.component.ts